export const LOADING = "loader";
export const LANGUAGE = "language";
export const NOTIFICATIONS = "notifications";
